import script from "./WorkspaceIntervalParentSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceIntervalParentSelector.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceIntervalParentSelector.vue?vue&type=style&index=0&id=6da7f5f7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da7f5f7"]])

export default __exports__